export default {
    state: {
        title: localStorage.getItem('title') || '',
        head: localStorage.getItem('head') || '',
        checkInId: localStorage.getItem('checkInId') || '',
        serviceTitle: localStorage.getItem('serviceTitle') || '',
        serviceHead: localStorage.getItem('serviceHead') || '',
        serviceId: localStorage.getItem('serviceId') || '',
        imgUrl:'http://resource.home121.net/',
        navId: '',
        navPath: ''
    },
    mutations: {
        // 处理版权登记的数据
        setCheckIn: (state) => {
            state.title = localStorage.getItem('title')
            state.head = localStorage.getItem('head')
            state.checkInId = localStorage.getItem('checkInId')
        },
        // 处理版权服务的数据
        setService: (state) => {
            state.serviceTitle = localStorage.getItem('serviceTitle')
            state.serviceHead = localStorage.getItem('serviceHead')
            state.serviceId = localStorage.getItem('serviceId')
        },

        // 顶部下拉框跳转
        pushList: (state, payload) => {
            state.navId = payload.navId
            state.navPath = payload.navPath
        }
    }
}